/**
* @version GENERATOR_VERSION::20200504
* @DateTime 2021-02-25T10:37:42.925
* @Author <a href=\"mailto:bigmouthz@foxmail.com\">bigmouthz</a>
**/
import BasicLayout from '@/layouts/basic-layout';

const meta = {
auth: true
};

const pre = 'rentmanage-renthousetypesales-'

export default 
{
path: '/rentmanage/renthousetypesales',
name: 'rentmanage-renthousetypesales',
redirect: {
name: '${pre}-index'
}
,

meta:{
...meta,
},

component: BasicLayout ,
children:
[
{
path: 'index',
name: '${pre}renthousetypesales-index',

meta:{
...meta,
title: '销售人员'
},

component: () => import('@/pages/rentmanage/renthousetypesales/index') ,
},
{
path: 'detail-edit/:id',
name: '${pre}renthousetypesales-detail-edit',
auth: [
'hidden'
],

meta:{
...meta,
title: '销售人员编辑'
},

component: () => import('@/pages/rentmanage/renthousetypesales/detail-edit') ,
},
{
path: 'detail-edit',
name: '${pre}renthousetypesalesdetail-create',
auth: [
'hidden'
],

meta:{
...meta,
title: '销售人员新增'
},

component: () => import('@/pages/rentmanage/renthousetypesales/detail-edit') ,
},
{
path: 'detail-view/:id',
name: '${pre}renthousetypesalesView',
auth: [
'hidden'
],

meta:{
...meta,
title: '销售人员详情查看'
},

component: () => import('@/pages/rentmanage/renthousetypesales/detail-view') ,
},
]
};
